import React from "react";
import "./customQuantityDisplay.css";
import { commonQtyColorSchemes, QtyColorSchemeOptions } from "./commonQtyColorSchemes";
import { getUomLabel } from "./DmsUtils";

interface CustomQuantityDisplayProps {
  caseQty: number;
  pieceQty: number;
  otherQty: number;
  colorScheme?:QtyColorSchemeOptions;
}

const CustomQuantityDisplay: React.FC<CustomQuantityDisplayProps> = ({ caseQty, pieceQty, otherQty, colorScheme='grey' }) => {
  const { caseUnitLabel, otherUnitLabel, packUnitLabel } = getUomLabel();
  const QtyComponent = ({label, value}:{label:string, value:number}) => {
    return (
      <div className="custom-qty-component">
        <div className="custom-qty-component-value" style={{color:commonQtyColorSchemes[colorScheme].value}}>{value}</div>
        <div className="custom-qty-component-label" style={{color:commonQtyColorSchemes[colorScheme].label}}>{label}</div>
      </div>
    )
  }
  return (
    <div className="custom-qty-display-container" style={{backgroundColor:commonQtyColorSchemes[colorScheme].background, minWidth:otherUnitLabel ? '100px' : '60px'}}>
        {caseUnitLabel &&<QtyComponent label={caseUnitLabel} value={caseQty} />}
        {otherUnitLabel && <QtyComponent label={otherUnitLabel} value={otherQty} />}
        {packUnitLabel && <QtyComponent label={packUnitLabel} value={pieceQty} />}
    </div>
  );
};

export default CustomQuantityDisplay;
